import Alpine from "alpinejs";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export const interviewTitleAnimation = () => {
  Alpine.data("interviewTitleAnimation", () => ({
    timeline: null as gsap.core.Timeline | null,
    init() {
      const root = this.$root as HTMLElement;
      const titleSvg = this.$refs.titleSvg as HTMLElement | null;

      if (!titleSvg) return;

      const subPaths = Array.from(
        titleSvg.querySelectorAll("#interview-title-sub path"),
      ) as SVGPathElement[];
      const circle = titleSvg.querySelector("#interview-title-circle") as SVGElement | null;
      const main = titleSvg.querySelector("#interview-title-main") as SVGElement | null;

      if (subPaths.length === 0 && !circle && !main) return;

      gsap.set(subPaths, { autoAlpha: 0, y: 16 });
      gsap.set(circle, { autoAlpha: 0, scale: 1.5, transformOrigin: "50% 50%" });
      gsap.set(main, { autoAlpha: 0 });

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: root,
          start: "top 80%",
          once: true,
        },
      });

      tl.to(
        circle,
        {
          autoAlpha: 1,
          scale: 1,
          duration: 0.6,
          ease: "power2.out",
        },
        0,
      )
        .to(
          subPaths,
          {
            y: 0,
            autoAlpha: 1,
            duration: 0.6,
            stagger: 0.05,
            ease: "power2.out",
          },
          "<",
        )
        .to(
          main,
          {
            autoAlpha: 1,
            duration: 1.6,
            ease: "power2.out",
          },
          "-=0.6",
        );

      this.timeline = tl;
    },
    destroy() {
      this.timeline?.scrollTrigger?.kill();
      this.timeline?.kill();
      this.timeline = null;
    },
  }));
};
